import { useI18n } from 'vue-i18n'
import { LocaleCodes, setI18nLanguage, type LocaleCode } from '../plugins/i18n.client'

export function useAppLocale() {
  const applyLocale = () => {
    const { isCurrentLangActive, primaryLocale, langCode } = storeToRefs(useStoreStore())

    const { fallbackLocale } = useI18n()

    let lang = isCurrentLangActive.value ? langCode.value : primaryLocale.value

    lang = lang ?? navigator.language

    const [appLang] = lang.split('-') as [LocaleCode]

    if (LocaleCodes.includes(appLang)) {
      setI18nLanguage(appLang)
    } else {
      const fallback = String(fallbackLocale.value) as LocaleCode
      setI18nLanguage(fallback)
    }
  }

  return { applyLocale }
}
